import React, { useState, useEffect } from "react";
import { Fieldset } from "primereact/fieldset";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { settingService } from "../../../services/extensions";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";

const ProjectForm = ({ onClose }) => {
  const [customers, setCustomers] = useState([]);
  const [projectTypes, setProjectTypes] = useState([]);

  useEffect(() => {
    getCustomers();
    getProjectTypes();
  }, []);
  const getCustomers = () => {
    settingService.getCustomers().then((resp) => {
      setCustomers(resp.data.data);
    });
  };

  const getProjectTypes = () => {
    settingService.getProjectTypes().then((resp) => {
      setProjectTypes(resp.data.data);
    });
  };
  const formik = useFormik({
    initialValues: {
      customers: "",
      projectTypes: "",
      code: "",
      title: "",
    },
    validate: (data) => {
      let errors = {};
      if (!data.customers) {
        errors.customers = "Customer is required.";
      }
      if (!data.projectTypes) {
        errors.projectTypes = "Project type is required.";
      }
      if (!data.code) {
        errors.code = "Code is required.";
      }
      if (!data.title) {
        errors.title = "Title is required.";
      }
      return errors;
    },
    onSubmit: (data) => {
      let param = {
        customerId: data.customers.id,
        projectTypeId: data.projectTypes.id,
        code: data.code,
        title: data.title,
      };
      createProjects(param);
      formik.resetForm();
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const createProjects = (data) => {
    try {
      settingService.addProject(data).then(
        (resp) => {
          toast.success("New project added");
          onClose();
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to add new project");
    }
  };

  const projectForm = (
    <Fieldset>
      <form
        onSubmit={formik.handleSubmit}
        className="p-fluid p-grid"
        autoComplete="off"
      >
        <div className="formgrid grid">
          <div className="field col-1 mt-1"></div>
          <div className="field col-4 mt-2 ">
            {" "}
            <strong>Customer: </strong>
          </div>
          <div className="field col-6">
            <span className="p-mt-4 p-input-icon-right">
              <span className="p-float-label">
                <Dropdown
                  filter
                  id="customers"
                  name="customers"
                  placeholder="Select customer"
                  options={customers}
                  value={formik.values.customers}
                  onChange={formik.handleChange}
                  optionLabel="title"
                  className={classNames({
                    "p-invalid": isFormFieldValid("customers"),
                  })}
                  style={{ width: "139px" }}
                />
              </span>
              {getFormErrorMessage("customers")}
            </span>
          </div>
        </div>

        <div className="formgrid grid">
          <div className="field col-1 mt-1 "></div>
          <div className="field col-4 mt-2 mr-1">
            {" "}
            <strong>Project Type: </strong>
          </div>
          <div className="field col-6">
            <span className="p-mt-4 p-input-icon-right">
              <span className="p-float-label">
                <Dropdown
                  id="projectTypes"
                  name="projectTypes"
                  placeholder="Select project type"
                  optionLabel="title"
                  options={projectTypes}
                  value={formik.values.projectTypes}
                  onChange={formik.handleChange}
                  className={classNames({
                    "p-invalid": isFormFieldValid("projectTypes"),
                  })}
                />
              </span>
              {getFormErrorMessage("projectTypes")}
            </span>
          </div>
        </div>

        <div className="formgrid grid">
          <div className="field col-1 mt-1"></div>
          <div className="field col-3 mt-2 mr-5">
            {" "}
            <strong>Code: </strong>
          </div>
          <div className="field col-6">
            <span className="p-mt-4 p-input-icon-right">
              <span className="p-float-label">
                <InputText
                  id="code"
                  name="code"
                  value={formik.values.code}
                  onChange={formik.handleChange}
                  className={classNames({
                    "p-invalid": isFormFieldValid("code"),
                  })}
                />
              </span>
              {getFormErrorMessage("code")}
            </span>
          </div>
        </div>

        <div className="formgrid grid">
          <div className="field col-1 mt-1"></div>
          <div className="field col-3 mt-2 mr-5">
            {" "}
            <strong>Title: </strong>
          </div>
          <div className="field col-6">
            <span className="p-mt-4 p-input-icon-right">
              <span className="p-float-label">
                <InputText
                  id="title"
                  name="title"
                  value={
                    formik.values.title.charAt(0).toUpperCase() +
                    formik.values.title.slice(1)
                  }
                  onChange={formik.handleChange}
                  className={classNames({
                    "p-invalid": isFormFieldValid("title"),
                  })}
                />
              </span>
              {getFormErrorMessage("title")}
            </span>
          </div>
        </div>

        <div className="formgrid grid mt-5">
          <div className="field col-3"></div>
          <div className="field col-4">
            <Button
              type="button"
              label="Cancel"
              icon="pi pi-times"
              className="p-button-rounded p-button-secondary p-mt-2"
              onClick={onClose}
            />
          </div>
          <div className="field col-4">
            <Button
              type="submit"
              label="Save"
              icon="pi pi-save"
              className="p-button-rounded p-button-primary p-mt-2"
            />
          </div>
        </div>
      </form>
    </Fieldset>
  );

  return <React.Fragment>{projectForm}</React.Fragment>;
};

export default ProjectForm;
